import { z } from "zod";
export const milkingVisitBehaviorIndexWeeklySchema = z.object({
    farmLicenseKey: z.string(),
    weekStartDate: z.string(),
    lactationGroup: z.string(),
    cowCount: z.number(),
    farmHerdCondition: z.number(),
    milkingVisitBehaviorIndex: z.number().nullable(),
    regularIntervalMilkingIndex: z.number().nullable(),
    irregularIntervalCowIndex: z.number().nullable(),
    irregularIntervalCowPercentage: z.number(),
    regularIntervalMilkingPercentage: z.number(),
    milkingVisitBehaviorIndexWeeklyChange: z.number().nullable(),
});
//# sourceMappingURL=milking-visit-behavior-index.schema.js.map